import React from 'react'

import { toggleColorEnum } from '../fields/toggle-button/toggleColorEnum'
import { Button } from '../../../shadcn/components/ui/button'
import { Mixpanel } from '../../../utils/Mixpanel'

interface IToggleProps {
  nameLeft: string | JSX.Element
  nameRight: string | JSX.Element
  value: boolean
  setValue: (value: boolean) => void
  className?: string
  disabled?: boolean
  toggleColor?: toggleColorEnum
  dataMixpanel?: { name: string; data?: any }
  dataTestId?: string
}

const Toggle = ({
  nameLeft,
  nameRight,
  setValue,
  value,
  className,
  dataMixpanel,
  dataTestId,
  disabled,
  toggleColor,
}: IToggleProps) => {
  return (
    <div
      className={`flex h-full ${className} ${disabled && 'pointer-events-none'}`}
    >
      <Button
        className={`relative left-[2px] h-full min-w-16 border bg-white ${
          value
            ? `border-${toggleColor} text-${toggleColor} z-10`
            : 'border-grey-500 text-grey-500'
        }`}
        variant='outlineWithoutHover'
        onClick={() => {
          if (!disabled) {
            setValue(true)
            if (dataMixpanel) {
              Mixpanel.track(dataMixpanel?.name, {
                value: nameLeft,
                data: dataMixpanel?.data,
              })
            }
          }
        }}
        disabled={disabled}
        data-testid={`${dataTestId}-left`}
      >
        {nameLeft}
      </Button>
      <Button
        className={`relative right-[2px] h-full min-w-16 border bg-white ${
          !value
            ? `border-${toggleColor} text-${toggleColor} z-10`
            : 'border-grey-500 text-grey-500'
        }`}
        variant='outlineWithoutHover'
        onClick={() => {
          if (!disabled) {
            setValue(false)
            if (dataMixpanel) {
              Mixpanel.track(dataMixpanel?.name, {
                value: nameRight,
                data: dataMixpanel?.data,
              })
            }
          }
        }}
        disabled={disabled}
        data-testid={`${dataTestId}-right`}
      >
        {nameRight}
      </Button>
    </div>
  )
}

export default Toggle
